<div class="flex flex-col items-center gap-y-6 px-6">
	<!-- header -->
	<div class="w-full flex gap-3 items-center">
		<span class="text-3xl font-bold whitespace-nowrap"
			>Connect to {{ name }}</span
		>
		<div class="flex-auto"></div>
		<img [src]="logoUrl" class="w-24" />
	</div>

	<!-- display the lawyer credentials required ONLY if its a clerk -->
	<div
		*ngIf="(userRole$ | async) === BusinessUserRole.CLERK"
		class="w-full flex items-center px-4 py-2"
		style="
			color: var(--purchase-bg-color);
			border: 2px solid #dcebfa;
			background: #f0f7fe;
		"
	>
		<app-icon class="float-left mr-4" [icon]="ICON.EXCLAMATION"></app-icon>
		<span class="text-sm" *ngIf="(allLawyers$ | async)?.length > 0"
			>A lawyer's credentials are required to connect to {{ name }}.</span
		>
		<span class="text-sm" *ngIf="(allLawyers$ | async)?.length === 0"
			>At least 1 lawyer is required to be added to Closer to connect to
			{{ name }}.</span
		>
	</div>

	<!-- show connected lawyers, if there are any -->
	<ng-container *ngIf="connectedUsers$ | async as connected">
		<div
			*ngIf="connected.length; else noConnectedLawyers"
			class="w-full flex items-center px-4 py-2 bg-grey-lightest"
		>
			<app-icon class="float-left mr-4" [icon]="ICON.LIGHTNING_BOLT"></app-icon>
			<span class="text-xs mr-4">Already connected</span>
			<ng-container *ngFor="let lawyer of connected">
				<ng-container
					*ngTemplateOutlet="lawyerCircle; context: { lawyer: lawyer }"
				></ng-container>
			</ng-container>
		</div>
	</ng-container>

	<!-- if lawyer, give em the login form -->
	<ng-container *ngIf="canLogin$ | async; cantLogin">
		<!-- if ALL lawyers are connected, display the message & invitation -->
		<ng-container *ngIf="areAllLawyersConnected$ | async; else loginForm">
			<ng-container *ngTemplateOutlet="allLawyersConnected"></ng-container>
			<ng-container *ngTemplateOutlet="invite"></ng-container>
		</ng-container>

		<ng-template #loginForm>
			<form
				*ngIf="(allLawyers$ | async)?.length"
				#loginForm="ngForm"
				[formGroup]="signInForm"
				(ngSubmit)="login()"
				class="contents"
			>
				<div class="flex flex-col gap-2">
					<app-dropdown
						[value]="selectedLawyerName"
						label="Lawyer"
						[itemGroups]="[{ items: (lawyerOptions$ | async) }]"
						(onSelect)="onLawyerSelect($event)"
					></app-dropdown>

					<app-input
						label="Username"
						placeholder="Username"
						[formControlName]="FORM_VALUES.USERNAME"
					></app-input>

					<app-input
						label="Password"
						placeholder="Password"
						[formControlName]="FORM_VALUES.PASSWORD"
						type="password"
					></app-input>
				</div>

				<ng-container *ngIf="showInviteOnLoginPage$ | async">
					<ng-container
						*ngTemplateOutlet="invite; context: { framed: true }"
					></ng-container>
				</ng-container>

				<!-- the buttons -->
				<div class="flex justify-between w-full">
					<app-button
						btn="secondary"
						size="small"
						class="mr-2"
						(click)="cancel()"
						>Cancel</app-button
					>
					<app-button
						type="submit"
						size="small"
						[loading]="loading$ | async"
						[disabled]="(loading$ | async) || signInForm.invalid"
						>Validate</app-button
					>
				</div>
			</form>
		</ng-template>
	</ng-container>

	<!-- errors and what-not -->
	<atomic-message-bar type="error" *ngIf="error || userTaken">
		<span *ngIf="error">{{ error }}</span>
		<span *ngIf="userTaken"
			>Unable to connect: credentials currently assigned to
			{{ userTaken.username }}</span
		>
	</atomic-message-bar>
</div>

<ng-template #cantLogin>
	<ng-container *ngIf="showInviteOnLoginPage$ | async">
		<ng-container *ngTemplateOutlet="invite"></ng-container>
	</ng-container>
</ng-template>

<ng-template #invite let-framed="framed">
	<div [class]="framed ? 'bg-grey-veryLight p-4 rounded-lg' : ''">
		Looking to add someone else?
		<app-anchor class="inline" type="static" (onClick)="goToInvite()"
			>Invite a new lawyer</app-anchor
		>
		to Closer and connect them to {{ name }}.
	</div>
</ng-template>

<!-- ALL lawyers are connected -->
<ng-template #allLawyersConnected>
	<span class="font-bold text-sm"
		>All lawyers in Closer are currently connected to {{ name }}.</span
	>
</ng-template>

<!-- no lawyer/tokens, display error message -->
<ng-template #noConnectedLawyers>
	<span class="font-bold text-sm"
		>There are currently no lawyers connected to {{ name }}.</span
	>
	<ng-container
		*ngIf="!(allLawyers$ | async)?.length && (showInviteOnLoginPage$ | async)"
	>
		<ng-template
			*ngTemplateOutlet="invite; context: { framed: true }"
		></ng-template>
	</ng-container>
</ng-template>

<!-- a circle doodad, the controls and options we have are either too much or require too much rejigging -->
<ng-template #lawyerCircle let-lawyer="lawyer">
	<div
		class="flex w-[35px] h-[35px] items-center justify-center rounded-md text-sm font-bold mr-2"
		style="background: #dcebfa; color: #133d7b"
		[matTooltip]="lawyer.name"
	>
		{{ lawyer.name | initials }}
	</div>
</ng-template>
